<template>
  <div class="fts-image-cropper">
    <div class="image-cropper-wrapper" @click="showUploader($event)">
      <img :src="filePath" />
    </div>

    <div class="image-cropper-action" v-if="!!mutableModel">
      <fts-btn
        sm
        icon
        box-shadow-none
        :disabled="uploading"
        @click="remove"
      >
        <font-awesome-icon :icon="['fas', 'times']" />
      </fts-btn>
    </div>

    <div class="image-cropper-action" v-else>
      <fts-btn
        sm
        icon
        color="primary"
        box-shadow-none
        :loading="uploading"
        @click.native="showUploader($event)"
      >
        <font-awesome-icon :icon="['fas', 'plus']" />
      </fts-btn>
    </div>

    <avatar-cropper
      :trigger="`#${uid}`"
      :upload-url="uploadURL"
      :upload-form-data="uploadFormData"
      :labels="{ submit: 'Done', cancel: 'Cancel' }"
      :output-options="outputOptions"
      :cropper-options="cropperOptions"
      ref="avatarCropper"
      @uploading="handleUploading"
      @completed="handleCompleted"
      @error="handleError"
      @uploaded="handleUploaded"
    />
    <!-- workaround solution; avatar cropper eventListner issue -->
    <div :id="`${uid}`" style="display: none;"></div>
  </div>
</template>

<script>
import webAppConfig from '../commons/webApp.config';
import AvatarCropper from 'vue-avatar-cropper';
import FTSBtn from './FTSBtn';

export default {
  components: {
    AvatarCropper,
    "fts-btn": FTSBtn
  },
  props: {
    uploadData: String,
    uploadURL: {
      type: String,
      default: webAppConfig.fileUploadURL
    },
    uploadFormData: Object,
    outputOptions: {
      type: Object,
      default: () => ({
        width: 512,
        height: 512,
      })
    },
    cropperOptions: Object,
    formatFilePath: {
      type: Function,
      default: (filePath) => {
        return filePath;
      }
    }
  },
  model: {
    prop: "uploadData",
    event: "updateUploadData"
  },
  data: () => ({
    uid: null,
    showCropper: false,
    uploading: false
  }),
  methods: {
    handleUploading(form, xhr) {
      this.uploading = true;
    },
    handleCompleted(res, form, xhr) {
      this.uploading = false;
    },
    handleError(msg, type, xhr) {
      this.$toasted.error(`${msg}`);
    },
    handleUploaded(res, form, xhr) {
      this.mutableModel = res.url;
    },
    showUploader(event) {
      if (this.uploading)
        return;

      this.$refs.avatarCropper.pickImage(event);
    },
    remove() {
      this.mutableModel = null;
    }
  },
  computed: {
    mutableModel: {
      get() {
        return this.uploadData;
      },
      set(val) {
        this.$emit("updateUploadData", val);
      }
    },
    filePath() {
      return this.formatFilePath(this.mutableModel);
    }
  },
  mounted() {
    this.uid = `pick-avatar-${this._uid}`;
  }
}
</script>

<style lang="scss">
.fts-image-cropper {
  height: 150px;
  position: relative;
  .image-cropper-wrapper {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.75rem;
    border-radius: 0.375rem;
    background-color: var(--fts-gray-100);
    overflow: hidden;
    cursor: pointer;
    > img {
      max-height: 100%;
      max-width: 100%;
      height: auto;
      width: auto;
    }
  }
  .image-cropper-action {
    position: absolute;
    bottom: -8px;
    right: -8px;
    padding: 0.25rem;
    border-radius: 50%;
    background-color: var(--fts-card-background);
  }

  .avatar-cropper {
    .avatar-cropper-overlay {
      margin-top: 55px;
      align-items: flex-start;
    }
    .avatar-cropper-close {
      text-decoration: none;
    }
    .avatar-cropper-container {
      .avatar-cropper-image-container {
        .cropper-crop-box {
          .cropper-view-box {
            border-radius: inherit;
            box-shadow: 0 0 0 1px #39f;
            outline: 0;
          }
          .cropper-face {
            background-color: inherit;
          }
          .cropper-dashed,
          .cropper-point.point-se,
          .cropper-point.point-sw,
          .cropper-point.point-nw,
          .cropper-point.point-ne,
          .cropper-line {
            display: none;
          }
          .cropper-view-box {
            outline: inherit;
          }
        }
      }
      .avatar-cropper-footer {
        .avatar-cropper-btn {
          &:hover {
            background-color: var(--fts-primary);
          }
        }
      }
    }
  }
}
</style>